
  <div class="row">

        <div class="col-12 text-left">
      <label>Add Your Pet name</label>
        </div>
        <div class="col-12 text-left">
      <input type="text" [(ngModel)]="name" class="form-control">
        </div>
  
  </div>
  <div class="row">

        <div class="col-12 text-left">
        <label style="margin-top: 20px;">Pet Type</label>
        </div>
        <div class="col-12 text-left">
        <select [(ngModel)]="type" class="fotm-control"> 
          <option value="dog">Dog</option>
          <option value="cat">Cat</option>
          <option value="Birds">Bird</option>
          <option value="Rabbit/Hamsters">Rabbit/Hamsters</option>
          <option value="Others">Others</option>
          
        </select>
        </div>

    </div>

    <div class="row">
  
        <div>
            <div class="col-12 text-left">
          <label   style="color:#000; margin-top: 20px">Date of Birth: </label>
            </div>
            <div class="col-12 text-left">
          <mat-form-field>
              <input type="date" time="false" date="true" mdInput name="dob" displayFormat="MMM DD YYYY"    [(ngModel)]="dob"
              [ngModelOptions]="{standalone: true}" >
          </mat-form-field>
             <mat-datepicker name="dob" id="dob" #myDatepicker></mat-datepicker>
            </div>
              </div>

    </div>

    <div class="row" *ngIf="sdetail && sdetail.length> 0"> 
    
            <div class="col-12 text-left">
          <label style="margin-top: 20px;">Reason of Appointment</label>
            </div>
            <div class="col-12 text-left">
          <select [(ngModel)]="rof" class="fotm-control"> 
            <option *ngFor="let s of sdetail" value={{s.id}}>{{s.name}}</option>
           
          </select>
            </div>
  
      </div>
      <div class="row" style="margin:5px; margin-top:20px">
<div class="col-6">
<button class="btn btn-success3" (click)="submitForm()">Submit</button>
</div>
<div class="col-6">
    <button class="btn btn-success" mat-dialog-close>Cancel</button> 
  </div>
      </div>


